// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2FdQX","additionalInfo":"AgreementModal_additionalInfo__2ayUK"};